<template>
  <v-dialog v-model="active" persistent max-width="600px">
    <material-card color="primary" :title="title" text="Choose a new PASSWORD">
      <v-form ref="form" v-model="validForm">
        <v-container py-0>
          <v-layout wrap>


            <v-flex xs12 md12>
              <v-text-field autocomplete="false" v-model="changeForm.oldpass" prepend-icon="mdi-lock" :append-icon="passwordType0 == 'password' ? 'mdi-eye' : 'mdi-eye-off'
                " @click:append="showPwd0" name="OLD password" label="OLD Password" id="input_old_password"
                :type="passwordType0" required :rules="validators.account.password">
              </v-text-field>
            </v-flex>


            <v-flex xs12 md12>
              <v-text-field  :disabled="!changeForm.oldpass" autocomplete="false" v-model="changeForm.newpass" prepend-icon="mdi-lock" :append-icon="passwordType1 == 'password' ? 'mdi-eye' : 'mdi-eye-off'
                " @click:append="showPwd1" name="NEW password" label="NEW Password" id="input_new_password"
                :type="passwordType1" required :rules="[
                  ...validators.account.password,
                  v => validators.different_password(v, changeForm.oldpass),
                  v => validators.strong_password(v)
                ]">
              </v-text-field>
            </v-flex>


            <v-flex xs12 md12>
              <v-text-field :disabled="!changeForm.oldpass" autocomplete="new-password" v-model="changeForm.confirmpass" prepend-icon="mdi-lock"
                :append-icon="passwordType2 == 'password' ? 'mdi-eye' : 'mdi-eye-off'
                  " @click:append="showPwd2" name="Confirm NEW password" label="Confirm NEW Password"
                id="input_confirm_password" :type="passwordType2" required :rules="validators.account.password">
              </v-text-field>
            </v-flex>

                <v-flex xs12 text-right>
                  <v-btn
                    v-if="!force"
                    color="primary"
                    class="mx-1 font-weight-light"
                    @click="close()">Close</v-btn>

              <v-btn id="button_confirm_change_password" color="primary" class="mx-1 font-weight-light" @click="confirm_change" :disabled="!canConfirm()"
                :loading="loading">Confirm</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </material-card>
  </v-dialog>
</template>

<script>
import { changePass } from "@/api/user"
import validators from "@/utils/validators"

export default {
  data: () => ({
    changeForm: {},
    validForm: true,
    loading: false,
    passwordType0: 'password',
    passwordType1: 'password',
    passwordType2: 'password',
    validators
  }),
  watch: {
    value(v) {
      if (v && this.$refs.form) {
        this.$refs.form.reset()
      }
    },
    'changeForm.oldpass'(newVal) {
      if(!newVal){
        this.changeForm.newpass='';
        this.changeForm.confirmpass='';
      }
    }
  },
  mounted() {
    this.changeForm.restore_pass_token = this.$route.query.restore_pass_token
    this.changeForm.email = this.$route.query.email;
  },
  computed: {
    title() {
      return this.$store.getters.changePass.title || "Change Password"
    },
    active() {
      return this.$store.getters.changePass.active || false;
    },
    force(){
      return this.$store.getters.changePass.force || false
    }
  },
  methods: {
    close() {
      this.changeForm = {}
      return this.$store.dispatch("app/closeChangePassword");
    },
    confirm_change() {
      changePass(this.changeForm)
        .then(() => {
          this.$root.$emit("openSnackbar", {
            message: "The new password has been stored correctly!",
            color: "success"
          })
          this.close()
        })
        .catch(e => {
          const error = e.response.data.message;
          this.$root.$emit("openSnackbar", {
            message: error,
            color: "warning"
          })
        })
    },
    showPwd0() {
      this.passwordType0 = this.passwordType0 === 'password' ? 'text' : 'password'
    },
    showPwd1() {
      this.passwordType1 = this.passwordType1 === 'password' ? 'text' : 'password'
    },
    showPwd2() {
      this.passwordType2 = this.passwordType2 === 'password' ? 'text' : 'password'
    },
    canConfirm() {
      return this.changeForm.confirmpass == this.changeForm.newpass && this.validForm;
    }
  },

}
</script>
